import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from '@yuno/sdk-web-core/dist/ui/primitives/button'

export const Container = styled.div<{ show: boolean }>`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
`

export const PaymentMethodsHeader = styled.h2`
  ${({ theme }) => css(theme.typographys.m.bold)};
  color: ${({ theme }) => theme.colors.neutrals.b};
  margin-bottom: 16px;
  ${({ theme }) => css`
    ${theme.breakpoints.desktop} {
      ${css({ ...theme.typographys.xl.bold })}
      margin-bottom: 16px;
    }
  `}
`

export const ButtonPay = styled(Button)`
  height: 48px;
  padding: 8px;
  border-radius: 10px;
  margin-top: 16px;
  margin-bottom: 16px;
`
